var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCardSimilarDataApproved = function SvgCardSimilarDataApproved(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 7V12C22.75 12.4142 22.4142 12.75 22 12.75C21.5858 12.75 21.25 12.4142 21.25 12V9.25L2.75 9.25L2.75 17C2.75 18.2426 3.75736 19.25 5 19.25H10C10.4142 19.25 10.75 19.5858 10.75 20C10.75 20.4142 10.4142 20.75 10 20.75H5C2.92893 20.75 1.25 19.0711 1.25 17V7C1.25 4.92893 2.92893 3.25 5 3.25H19C21.0711 3.25 22.75 4.92893 22.75 7ZM21.25 7V7.75L2.75 7.75V7C2.75 5.75736 3.75736 4.75 5 4.75L19 4.75C20.2426 4.75 21.25 5.75736 21.25 7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18C6.55229 18 7 17.5523 7 17C7 16.4477 6.55229 16 6 16C5.44772 16 5 16.4477 5 17C5 17.5523 5.44772 18 6 18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7456 16.0283C23.0282 15.7255 23.0119 15.2509 22.709 14.9683C22.4062 14.6857 21.9316 14.7021 21.649 15.0049L17.0117 19.9734C16.9246 20.0668 16.7811 20.0794 16.6789 20.0028L13.6473 17.7291C13.3159 17.4806 12.8458 17.5477 12.5973 17.8791C12.3488 18.2105 12.4159 18.6806 12.7473 18.9291L15.7789 21.2028C16.494 21.7392 17.4984 21.6504 18.1083 20.9969L22.7456 16.0283Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCardSimilarDataApproved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "card-similar-data-approved.0fe4e56449acaea17405f296ac8dc63a.svg";